/* eslint-disable react/no-unused-state */

import AnalyticsHelper from "../modules/AnalyticsHelper";
import Carousels from "./Carousels";
import CartAPI from "../modules/CartAPI";
import EventsAPI from "../modules/EventsAPI";
import InfoContainer from "../containers/InfoContainer";
import NonMemberCartAPI from "../modules/NonMemberCartAPI";
import Notification from "./Notification";
import ProductDescriptorViewsAPI from "../modules/ProductDescriptorViewsAPI";
import ProductDetailButtons from "./ProductDetailButtons";
import ProductDetails from "./ProductDetails";
import PropTypes from "prop-types";
import RatingsAndReviews from "../../bundles/Product/components/RatingsAndReviews";
import React from "react";
import RecommendedItems from "./RecommendedItems";
import Star from "./Star";
import {withRouter} from "react-router";
export default withRouter(class Product extends React.PureComponent {

  static propTypes = {
    "addToCartRequest": PropTypes.func.isRequired,
    "addWishListRequest": PropTypes.func.isRequired,
    "eligibleForFineJewelry": PropTypes.bool.isRequired,
    "location": PropTypes.object.isRequired,
    "nonMemberCartEnabled": PropTypes.bool.isRequired,
    "order": PropTypes.object,
    "productDescriptor": PropTypes.object,
    "removeWishListRequest": PropTypes.func.isRequired,
    "wishlisted": PropTypes.bool
  };

  static defaultProps = {
    "eligibleForFineJewelry": false,
    "order": {},
    "productDescriptor": {},
    "wishlisted": false
  };

  constructor (props) {
    super(props);
    const {"location": {search, pathname}} = props;
    this.state = {
      "cartItemNotification": null,
      "fromClearance": (/from_clearance=true/).test(search),
      "itemAvailability": null,
      "jewelryLocation": pathname,
      "loadingAddToCart": false,
      "roxySearchEnabledPage": Boolean(document.documentElement.dataset.roxySearchEnabledPage).toString(),
      "timerId": null
    };
  }

  componentDidMount () {
    const {"productDescriptor": {id}} = this.props;
    this.setItemAvailability(id);

    const {"productDescriptor": {sku}} = this.props;
    if (sku) {
      this.sendViewedProductEvent();
    }

    document.documentElement.dataset.roxySearchEnabledPage = "false";
  }

  componentWillUpdate = (nextProps) => {
    const {"productDescriptor": {"id": newId}} = nextProps;
    const {"productDescriptor": {"id": currentId}} = this.props;

    if (currentId !== newId) {
      this.setItemAvailability(newId);
    }
  }

  componentWillUnmount = () => {
    const {roxySearchEnabledPage} = this.state;
    document.documentElement.dataset.roxySearchEnabledPage = roxySearchEnabledPage;
  }

  sendViewedProductEvent = () => {
    const {productDescriptor} = this.props;

    AnalyticsHelper.sendProductViewedEvent(productDescriptor);
    EventsAPI.trackBrowserAbandonment(productDescriptor.id);
    ProductDescriptorViewsAPI.createProductDescriptorView(productDescriptor.id, "product_descriptor_page");
  }

  addWishListRequest = (prodId) => {
    const {addWishListRequest, "productDescriptor": {id}} = this.props;
    addWishListRequest(prodId, id !== prodId);
  };

  setLoadingAddToCart = (bool) => {
    this.setState({"loadingAddToCart": bool});
  }

  addToCartRequest = async (productDescriptorId, quantity) => {
    this.setLoadingAddToCart(true);
    const {fromClearance} = this.state;
    const storeKind = fromClearance ? "clearance" : "retail";
    await CartAPI.addToCart(productDescriptorId, quantity, storeKind, this.handleAddToCartNotification);
    this.setState({"timerId": this.removeCartItemNotification()});
    this.setLoadingAddToCart(false);
  }

  handleAddToCartNotification = (notificationText) => {
    const {timerId} = this.state;
    this.setCartItemNotification(timerId, notificationText);
  };

  removeCartItemNotification = () => {
    const timerId = setTimeout(() => {
      this.setState({"cartItemNotification": null});
    }, 5000);
    return timerId;
  };

  setCartItemNotification = (timerId, notificationText) => {
    clearTimeout(timerId);
    this.setState({"cartItemNotification": notificationText});
  };

  setItemAvailability = (id) => {
    const {fromClearance} = this.state;
    const storeKind = fromClearance ? "clearance" : "retail";

    NonMemberCartAPI.getItemAvailabilityCount(id, storeKind).then((response) => {
      this.setState({"itemAvailability": response});
    });
  };

  removeWishListRequest = (prodId) => {
    const {"productDescriptor": {id}, removeWishListRequest} = this.props;
    removeWishListRequest(prodId, id !== prodId);
  };

  render () {
    const {
      eligibleForFineJewelry,
      location,
      nonMemberCartEnabled,
      "productDescriptor": {
        "details": {
          "designer": designerName,
          "full_size_urls": images,
          "insider_price_dollars": insiderPriceDollars,
          "is_fine": isFine,
          name,
          ratings,
          wishlistable
        },
        id, sku
      },
      wishlisted
    } = this.props;
    const {fromClearance, cartItemNotification, itemAvailability, loadingAddToCart} = this.state;
    return (
      <div id="Product">
        <div id="product-container-bg">
          <div id="product-container">
            <div id="product-section-container">
              <div className="product-section">
                <div className="carousels">
                  <Carousels
                    designerName={designerName}
                    images={images}
                    name={name}
                  />
                  {wishlistable && (!isFine || eligibleForFineJewelry) &&
                  <Star
                    addWishListCallback={this.addWishListRequest}
                    id={id}
                    price={insiderPriceDollars}
                    removeWishListCallback={this.removeWishListRequest}
                    sku={sku}
                    wishlisted={wishlisted}
                  />}
                </div>
                <div className="product-details-info-and-buttons">
                  <InfoContainer
                    itemAvailability={itemAvailability}
                    parentProps={this.props}
                    showClearancePrice={fromClearance}
                    wishlisted={wishlisted}
                  />
                  <ProductDetailButtons
                    addToCartCallback={this.addToCartRequest}
                    addWishListCallback={this.addWishListRequest}
                    eligibleForFineJewelry={eligibleForFineJewelry}
                    id={id}
                    itemAvailability={itemAvailability}
                    loadingAddToCart={loadingAddToCart}
                    nonMemberCartEnabled={nonMemberCartEnabled}
                    parentProps={this.props}
                    removeWishListCallback={this.removeWishListRequest}
                    showClearancePrice={fromClearance}
                    wishlisted={wishlisted}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="product-section">
            <ProductDetails
              parentProps={this.props}
              showClearanceDetails={fromClearance}
            />
            <RatingsAndReviews
              location={location}
              productDescriptorId={id}
              ratings={ratings}
            />
          </div>
        </div>
        <div className="product-section">
          <RecommendedItems forProductDescriptorId={id} />
        </div>
        {cartItemNotification &&
          <Notification
            notificationDisplayText={cartItemNotification}
          />
        }
      </div>
    );
  }
});
